import { Component, OnInit } from '@angular/core';
import {FormsModule, FormGroup, FormControl, Validators} from '@angular/forms';
import { LoadService } from '../../services/load.service';
import { StockService } from '../../services/stock.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reimprimiretiqueta',
  templateUrl: './reimprimiretiqueta.component.html',
  styleUrls: ['./reimprimiretiqueta.component.css']
})
export class ReimprimiretiquetaComponent implements OnInit {

  public etiquetas:any[];
  public etiqueta:any;
  public formBuscar:FormGroup;
  public alert:string;
  public isopen:boolean;

  constructor(private _loaddata:LoadService, private _stockService:StockService,private datePipe: DatePipe) {
    this.etiquetas = [];
    this.etiqueta = {
      'idcaja': '',
      'prefijo' : '',
      'sufijo':'',
      'producto': '',
      'presentacion':'',
      'peso':'',
      'calibre':'',
      'elaboracion':'',
      'vencimiento':'',
      'qr':'',
      'lote':'',
      'op':'',
      'cliente':'',
      'tipocaja':'',
      'motivo':'',
      'responsable':''
    }

    this.formBuscar = new FormGroup({
      'codigoqr' : new FormControl('',Validators.required),
      'motivo': new FormControl('',Validators.required),
      'responsable': new FormControl('', Validators.required)
    })
    this.alert = '';
    this.isopen = false;
 }

  ngOnInit() {
  }

  onSearch(){
    let qr = this.formBuscar.get('codigoqr').value;
    //console.log("Código QR: ", qr);

    if(qr != null && qr != ''){
      this.alert = "Realizando busqueda.";
      this.isopen = true;
      this._loaddata.loadChange(20);
      let variable = '';
      let guion = 0;
      let prefijopallet = '';
      let sufijocaja = '';
      let prefijo = 0;
      let sufijo = 0;

      /*Derrepente la pistola lee 3 caracteres raros*/
      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      /*P18-0000-131-*/
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      if(regexp.test(qr)){
        //console.log("Ha ingresado un código de pallet");
      }
      else{
        for(let char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            prefijo = parseInt(variable);
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = parseInt(variable);
            variable = '';
            guion = 2;
          }
        }


        if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
          this._stockService.getOneStock(prefijo.toString(),sufijo.toString()).subscribe(
            (response:any) => {
                   let agregar = true;
                   for(let etiqueta of this.etiquetas){
                     if(etiqueta.idcaja === response.id){
                       agregar = false;
                     }
                   }

                   if(agregar){
                     //console.log("Caja Buscada: ", response);

                     let peso = 0;
                     let packing = 'Sin información.';
                     let qr = 'Sin información';
                     let cliente = 'Sin información';
                     let ordenproduccion = 'Sin información';
                     let motivo = this.formBuscar.get('motivo').value;
                     let responsable = this.formBuscar.get('responsable').value;

                     if(response.relationships.tag.data.attributes.code != null && response.relationships.tag.data.attributes.code != ''){
                       qr = response.relationships.tag.data.attributes.code;
                     }

                     if(response.relationships.tag.data.relationships.packing.data != null){
                       packing = response.relationships.tag.data.relationships.packing.data.id;
                     }

                     if(response.relationships.tag.data.relationships.production_order.data != null){
                       cliente = response.relationships.tag.data.relationships.production_order.data.attributes.client;
                       ordenproduccion = response.relationships.tag.data.relationships.production_order.data.attributes.number;
                     }

                     if(parseInt(response.relationships.tag.data.attributes.residue) != 0){
                       peso = parseInt(response.relationships.tag.data.attributes.residue);
                     }
                     else{
                       peso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
                     }

                     this.etiqueta = {
                       'idcaja': response.id,
                       'prefijo' : response.relationships.tag.data.attributes.prefix,
                       'sufijo':response.relationships.tag.data.attributes.suffix,
                       'producto': response.relationships.tag.data.relationships.product.data.attributes.code,
                       'presentacion':response.relationships.tag.data.relationships.product.data.relationships.properties.data[7].attributes.name+'-'+response.relationships.tag.data.relationships.product.data.relationships.properties.data[8].attributes.name+'-'+response.relationships.tag.data.relationships.product.data.relationships.properties.data[11].attributes.name,
                       'peso':peso,
                       'calibre':response.relationships.tag.data.relationships.product.data.relationships.properties.data[7].attributes.name,
                       'elaboracion':response.relationships.tag.data.attributes.elaboration_date,
                       'vencimiento':response.relationships.tag.data.attributes.expiration_date,
                       'qr':qr,
                       'lote':response.relationships.tag.data.relationships.lot.data.attributes.code,
                       'op':ordenproduccion,
                       'cliente':cliente,
                       'tipocaja':response.relationships.tag.data.relationships.box_type.data.id,
                       'motivo':motivo,
                       'responsable':responsable,
                     }

                     if(this.etiqueta.qr === 'Sin información'){
                       this.etiqueta.qr = this.etiqueta.prefijo+'-'+this.etiqueta.sufijo+'-'+this.etiqueta.producto+'-'+this.datePipe.transform(this.etiqueta.elaboracion, 'dd/MM/yyyy')+'-'+this.etiqueta.lote+'-'+this.etiqueta.op+'-PESO('+this.etiqueta.peso+'Kg)-'+this.etiqueta.cliente;
                     }

                     this.etiquetas.push(this.etiqueta);
                     this.limpiarEtiqueta();
                     this.formBuscar.reset();
                     this.formBuscar.patchValue({
                       'codigoqr': '',
                       'motivo':'',
                       'responsable':''
                     });
                     console.log("ETIQUETAS: ", this.etiquetas);
                     this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                     this.isopen = true;
                     this._loaddata.loadChange(100);
                     this.onClosedAutomatic();

                   }
                   else{
                     this.alert = "La Etiqueta ya fue agregada para su reimpresión.";
                     this.isopen = true;
                     this._loaddata.loadChange(100);
                     this.onClosedAutomatic();
                     this.limpiarEtiqueta();
                     this.formBuscar.reset();
                     this.formBuscar.patchValue({
                       'codigoqr': '',
                       'motivo':'',
                       'responsable':''
                     });
                   }


            },
            (error) => {
              this.alert = 'Caja no encontrada en el sistema.';
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.onClosedAutomatic();
            }
          );
        }
        else{
          this.alert = "Codigo QR invalido.";
          this.isopen = true;
          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
        }
      }
    }
  }

  quitarEtiqueta(pos:number){
    /*eliminando la caja segun la posicion en el array de cajas*/
    this.etiquetas.splice(pos,1);
    if(this.etiquetas.length == 0){
      /*limpiar*/
      this.limpiarEtiqueta();
      this.formBuscar.reset();
      this.formBuscar.patchValue({
        'codigoqr': '',
        'motivo':'',
        'responsable':''
      });
    }
  }

  onSubmit(){
    this.print();
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style></style>
        </head>
        <body onload="window.print();window.close()">
          ${printContents}
        </body>
      </html>`
    );
    popupWin.document.close();
  }


  /*Cierra el mensaje de alerta despues de 5 segundos*/
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 5000);

  }

  /*cierra el alert*/
  onClosed(){
    this.isopen = false;
  }

  limpiarEtiqueta(){
    this.etiqueta = {
      'idcaja': '',
      'prefijo' : '',
      'sufijo':'',
      'producto': '',
      'presentacion':'',
      'peso':'',
      'calibre':'',
      'elaboracion':'',
      'vencimiento':'',
      'qr':'',
      'lote':'',
      'op':'',
      'cliente':'',
      'motivo':'',
      'responsable':''
    }
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/reimprimiretiqueta/reimprimiretiqueta.component.ts